<template>
  <div class="settings-wrapper">
    <h3>settings</h3>

    <div class="settings-navigation">
      <router-link to="/settings/profile" class="link">
        profile settings
      </router-link>

      <router-link to="/settings/tag-settings" class="tag-settings link">
        <img v-if="hasSuggestedTags" class="notification-img" src="@/assets/images/notification_suggested_tag.png" alt="suggested-tag-notification">
        tag settings
      </router-link>

      <router-link to="/settings/manage-users" class="link">
        manage users
      </router-link>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: 'Settings',

  computed: {
    ...mapGetters([
      'hasSuggestedTags'
    ])
  }
}
</script>

<style lang="sass" scoped>
.settings-wrapper
  text-align: center
  padding-top: 2rem
  max-width: 800px
  margin: 0 auto

  .settings-navigation
    display: flex
    margin-top: 50px
    justify-content: space-evenly

  .link
    font-size: large
  .tag-settings
    position: relative

  h3
    font-size: 24px

  .notification-img
    position: absolute
    right: -6px
    top: -6px
    width: 13px
</style>